import { useTranslation } from 'react-i18next';

import styles from './EmptySection.module.css';

const EmptySection = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.empty}>
      <i className="fas fa-inbox" />

      <p>{message ?? t('projectProgress.noLoadedData')}</p>
    </div>
  );
};

export default EmptySection;
